<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/transmission/xushui/xs.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    Xushui Transmission Plant
                </div>
                <div class="manufacture-t2">
                    Located in Xushui District, Baoding City, Hebei Province, the factory broke ground in October 2015, covering an area of 145,000 square meters.<br />
                    It mainly produces 7DCT and 150/200 kW electric drive axle assemblies, with an annual assembly capacity of 1.2 million units, as well as in-house manufacturing capacity of 500,000 shaft & gear sets and 700,000 housings per year.
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                7DCT Assembly Line 1/2/3/4, 3eAD150 Assembly Line
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL Test
                            </div>
                            <div class="destils">
                                ① High Automation: 100% automated design with precision positioning and docking system. Automatic loading and clamping, real-time monitoring of key test parameters, automatic feedback of test results, automatic analysis and storage of test data, and test curve output are available.<br />
                                ② Precise Control & High Repeatability: Adopts high-performance SIEMENS motors and control system, capable of fully simulating actual vehicle working conditions. Closed-loop control of process parameters, vehicle signal simulation, and data validation via transmission TCU ensure data consistency and validity, with highly consistent test processes and parameters.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/xushui/xs1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                EOL Test
                            </div>
                            <div class="destils">
                                ③ High Integration & Intelligence: Programmable test software enables multi-product compatible testing with strong software scalability. Integrated with cutting-edge international NVH analysis system, it accurately detects transmission noise online in real time through speed and torque fluctuation analysis..<br />
                                ④ Efficiency & Cost: Combined with 100% automation and 90% equipment availability, it ensures both overall test efficiency and quality.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/xushui/xs1-1.jpg" alt="">
                        </div>
                    </div>


                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                7eAD200 Assembly Line
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/xushui/xs2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                EOL Test
                            </div>
                            <div class="destils">
                                ① NVH testing adopts robotic docking for greater flexibility.<br />
                                ② Network security requirements are added to the inspection software, with one-to-one encryption for each device.
                            </div>
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                7eAD150 Assembly Line
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="text-box ">
                            <div class="title">
                                EOL Test
                            </div>
                            <div class="destils">
                                ① The auxiliary pressing mechanism adopts quick-change docking for easy replacement and maintenance of worn parts.<br />
                                ② The clamping points of the additional jaws are equipped with copper shim transitions to prevent workpiece damage during clamping.<br />
                                ③ The NVH sensors adopt the latest rear-outlet wiring design, which provides a longer service life.
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/transmission/xushui/xs3-1.jpg" alt="">
                        </div>
                    </div>

                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>



    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: 'Xushui Transmission Plant - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/manufacture/tr/xushui.html'
};

import { createApp } from 'vue';
import App from './xushui.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./xushui.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
